const FILTER_URL = 'service/flow/filter';
const APPLICATION_JSON = 'application/json;charset=UTF-8';
export const createFilterIntegration = ({
  fetch
}) => {
  const handleFeeTypeChange = feeType => {
    return fetch(FILTER_URL, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': APPLICATION_JSON
      },
      body: JSON.stringify({
        paymentMethodFilterModel: [{
          id: feeType.id,
          numBaggage: -1
        }]
      })
    });
  };
  return {
    handleFeeTypeChange
  };
};